import React, { useMemo, useState, useEffect } from 'react';
import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { Card, FormLabel, FormControl, Grid, RadioGroup, Box, FormControlLabel, Radio,Button } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

function FundingShotStep2(props) {
    const isMobile = useMediaQuery('(max-width:600px)');
    const [value, setValue] = React.useState('female');
    return (
        <>
            <Box>
                <Header />
                <Box>
                    <Card sx={{
                        borderRadius: isMobile ? "0px": "0px 0 0 140px", // Rounded on the left only
                        boxShadow: 0,
                        marginBottom:2
                       
                    }}>
                        <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ width: "100%", padding:isMobile ? "10px": "0px 100px 0px 100px" }}>
                            <Grid item lg={8} md={8} sm={12} xs={12}>
                                <Grid container item lg={12} md={12} sm={12} xs={12}>
                                    <img
                                        src={require("../../../assets/images/SecondFundingOffer.png")} // update path
                                        alt="Business meeting"
                                        style={{ width: "80%", height: "auto", objectFit: "cover" }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item lg={4} md={4} sm={12} xs={12}>
                                <Grid container item lg={12} md={12} sm={12} xs={12} mt={1}>
                                    <FormControl>
                                        <FormLabel id="demo-controlled-radio-buttons-group" sx={{ fontWeight: "bold" }}>Are You Looking For Business Funding?</FormLabel>
                                        <RadioGroup
                                            aria-labelledby="demo-controlled-radio-buttons-group"
                                            name="controlled-radio-buttons-group"
                                            value={value}
                                        >
                                            <FormControlLabel value="female" control={<Radio />} label="Yes" />
                                            <FormControlLabel value="male" control={<Radio />} label="No" />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                                <Grid container item lg={12} md={12} sm={12} xs={12} mt={1}>
                                    <FormControl>
                                        <FormLabel id="demo-radio-buttons-group-label" sx={{ fontWeight: "bold" }}>How Much Funding Do You Need?​</FormLabel>
                                        <RadioGroup
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            defaultValue="female"
                                            name="radio-buttons-group"
                                        >
                                            <FormControlLabel value="female" control={<Radio />} label="Less Than $50,000​" />
                                            <FormControlLabel value="male" control={<Radio />} label="$50,000 To $100,000​" />
                                            <FormControlLabel value="other" control={<Radio />} label="$100,000 To $250,000​" />
                                            <FormControlLabel value="other" control={<Radio />} label="More Than $250,000​​" />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                                <Grid container item lg={12} md={12} sm={12} xs={12} mt={2}>
                                    <Button variant="contained" color="success" size="medium" sx={{
                                        backgroundColor: "#3FAC19",
                                        fontWeight: "bold",
                                        minWidth:isMobile?"100%": "300px",
                                        // minHeight: "50px",
                                        fontSize: "16px",
                                        borderRadius: "10px",
                                        animation: "blink 1.5s infinite",
                                            "@keyframes blink": {
                                                "0%": { backgroundColor: "#3FAC19" }, 
                                                "50%": { backgroundColor: "#55cc28" }, 
                                                "100%": { backgroundColor: "#3FAC19" },
                                            },
                                    }}>Next</Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Card>
                </Box>
                <Footer />
            </Box>
        </>
    );
}





export default FundingShotStep2;